<template>
  <KCrudLayout :filters.sync="filters">
  <template #filters="{attrs, on}">
    <PublicApiLogFilter v-bind="attrs" v-on="on"/>
  </template>
  <template #view.list>
    <resource
      class="public-api-log-resource"
      :can-add="false"
      :can-delete="false"
      :can-update="false"
      :show-speed-dial="true"
      :parameters="filters"
      :index-request="indexHandler"
      :meta="{name: $tc('publicApiLog.title', 1), namePlural: $tc('publicApiLog.title', 2)}"
      :table-content="tableContent"
      @row-click="openPublicApiLog"
      ref="resource">
    </resource>

    <v-dialog v-model="isPublicApiLogDialogOpen" width="1600" max-width="90vw">
      <v-card>
        <v-card-title>
          {{ $t('publicApiLog.title') }}
        </v-card-title>

        <v-row>
          <v-col cols="12" md="6">
            <v-card-text>
              <pre>{{dialogLogInput}}</pre>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="6">
            <v-card-text>
              <pre>{{dialogLogOutput}}</pre>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </template>
</KCrudLayout>
</template>

<script lang="js">
import { index } from "@/api/endpoints/publicApi.js";
import Resource from "@/components/Resource.vue";
import eventBus from "@/eventBus.js";
import { mapGetters } from "vuex";
import dayJs from "@/plugins/dayJs.js";
import PublicApiLogFilter from "@/components/forms/PublicApiLogFilter.vue";
import KCrudLayout from "@/components/layout/KCrudLayout.vue";

export default {
  name: 'PublicApiLogResource',
  components: {
    KCrudLayout,
    PublicApiLogFilter,
    Resource,
  },
  props: {
    client: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters("profile", ["can"]),
    tableContent() {
      return [
        {
          text: this.$t('publicApiLog.fields.type'),
          align: 'left',
          sortable: true,
          value: 'type',
        },
        {
          text: this.$t('publicApiLog.fields.reference'),
          align: 'left',
          sortable: true,
          value: 'reference',
        },
        {
          text: this.$t('publicApiLog.fields.statusCode'),
          align: 'left',
          sortable: true,
          value: 'statusCode',
        },
        {
          text: this.$t('publicApiLog.fields.createdAt'),
          align: 'left',
          sortable: true,
          value: 'createdAt',
        },
      ];
    },
  },
  data() {
    return {
      isPublicApiLogDialogOpen: false,
      dialogLogInput: "",
      dialogLogOutput: "",
      filters: {
        type: "SalesOrder.Store",
        dateFrom: dayJs().subtract(1, 'day').format('YYYY-MM-DD'),
        showSuccessful: false
      },
    };
  },
  created() {
    eventBus.$emit('setBreadcrumbs', [
      {
        exact: true,
        to: { name: 'home' },
        text: this.$t('global.dashboard'),
      },
      {
        exact: true,
        to: { name: 'client.index' },
        text: this.$tc('client.title', 2),
      },
      {
        exact: true,
        to: { name: 'client.connectors' },
        text: this.client.name,
      },
      {
        exact: true,
        to: { name: 'client.publicApiLog' },
        text: this.$tc('publicApiLog.title', 2),
      },
    ]);
  },
  methods: {
    async indexHandler() {
      const response = await index(this.$route.params.clientId, ...arguments);

      response.data.data.map(data => {
        data.createdAt = dayJs(data.createdAt).format('LLL');
        return data;
      });

      return response;
    },
    openPublicApiLog(logId) {
      const log = this.$refs.resource.$refs.resourceList.items.find(item => item.id === logId);

      this.dialogLogInput = log.message ? JSON.stringify(JSON.parse(log.message), null, 2) : "";
      this.dialogLogOutput = log.errorMessage ? JSON.stringify(JSON.parse(log.errorMessage), null, 2) : "";
      if (!this.dialogLogInput && !this.dialogLogOutput) {
        return;
      }
      this.isPublicApiLogDialogOpen = true;
    },
  },
};
</script>
